'use strict';

/**
 * Moves the Portfolio Featured Content tiles out of their hidden source container and into the
 * Content Grid at the configured, 1-based indexes.
 *
 * Featured Content components are paired with the indexes by order of definition
 * (first component -> first index, and so on). Components without a valid index, or whose index
 * is beyond the current grid size, are appended at the end of the grid.
 */
module.exports = {
    init: function () {
        var $source = $('.js-featured-content-source');
        if (!$source.length) {
            return;
        }

        var $grid = $('.js-content-grid').first();
        if (!$grid.length) {
            return;
        }

        // Featured Content tiles, in order of definition. The tiles may be wrapped in one or more
        // region containers, so collect every .experience-component within the source and keep only
        // the top-most ones (ignoring any .experience-component nested inside a Featured Content tile).
        var $featured = $source.find('.experience-component').filter(function () {
            return $(this).parentsUntil($source, '.experience-component').length === 0;
        });
        if (!$featured.length) {
            $source.remove();
            return;
        }

        // Parse the comma-separated, 1-based indexes (jQuery may coerce a single value to a number)
        var indexAttr = ($source.data('featuredIndexes') || '').toString();
        var indexes = indexAttr.split(',').map(function (value) {
            return parseInt($.trim(value), 10);
        });

        $featured.each(function (i) {
            var $component = $(this);
            var targetIndex = indexes[i];
            var $items = $grid.children();

            if (!Number.isNaN(targetIndex) && targetIndex >= 1 && targetIndex <= $items.length) {
                // Insert before the tile currently occupying the 1-based target position
                $items.eq(targetIndex - 1).before($component);
            } else {
                // No valid index (or beyond the grid) -> append at the end
                $grid.append($component);
            }
        });

        $source.remove();
    }
};
